export enum Scope {
  NONE = 0b00000000000000, // 0
  LOCATION_GUEST = 0b00000000000001, // 1
  LOCATION_SERVICE_REPRESENTATIVE = 0b00000000000010, // 2
  LOCATION_SERVICE_TECHNICIAN = 0b00000000000100, // 4
  LOCATION_ADMIN = 0b00000000001000, // 8
  SITE_SERVICE_REPRESENTATIVE = 0b00000000010000, // 16
  SITE_SERVICE_TECHNICIAN = 0b00000000100000, // 32
  SITE_ADMIN = 0b00000001000000, // 64
  PRESENCE_SERVICE_REPRESENTATIVE = 0b00000010000000, // 128
  PRESENCE_SERVICE_TECHNICIAN = 0b00000100000000, // 256
  PRESENCE_ADMIN = 0b00001000000000, // 512
  CUSTOMER_SERVICE_REPRESENTATIVE = 0b00010000000000, // 1024
  CUSTOMER_SERVICE_TECHNICIAN = 0b00100000000000, // 2048
  CUSTOMER_ADMIN = 0b01000000000000, // 4096
  GLOBAL_ADMIN = 0b10000000000000, // 8192
}
